import { createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  loadStatusables(event) {
    event.preventDefault();
    const link = event.currentTarget;
    document.dispatchEvent(createCustomEvent('status-button-click', this.element, { url: link.href, status: link.dataset.status }));
  }
};



// WEBPACK FOOTER //
// ./app/components/statusables/assets/javascript/statusables-status-options-controller.js